import $ from 'jquery';

export default {
  debounce(func, threshold, execAsap) {
    let timeout = false;

    return () => {
      const obj = this;
      const args = arguments;

      const delayed = () => {
        if (!execAsap) { func.apply(obj, args); }
        timeout = null;
      };

      if (timeout) {
        clearTimeout(timeout);
      } else if (execAsap) {
        func.apply(obj, args);
      }

      timeout = setTimeout(delayed, threshold || 100);
    };
  },

  windowWidth() {
    return window.innerWidth || document.documentElement.clientWidth;
  },

  windowHeight() {
    return window.innerHeight || document.documentElement.clientHeight;
  },

  scrollTarget($el) {
    if (!($el instanceof jQuery)) {
      $el = $($el);
    }

    let offset = $el.offset().top;

    const $stickyHeader = $('[data-sticky-header]');

    if ($stickyHeader.length && (window.innerWidth >= 720)) {
      offset -= $stickyHeader.outerHeight();
    }

    $('html, body').animate(
      { scrollTop: offset },
      500, 'linear',
    );
  },

  externalLinks($el) {
    const anchors = $el.find('a[href^="http"]').filter((i, el) => el.href.indexOf(location.hostname) === -1);

    anchors.attr('target', '_blank');
  },

  extend(dest, ...objs) {
    let result = { ...dest };
    objs.forEach((obj) => {
      result = { ...result, ...obj };
    });

    return result;
  },

  unique(array) {
    const output = {};

    array.forEach((value) => {
      output[value] = value;
    });

    return Object.keys(output);
  },
};
